module.exports = __webpack_public_path__ + "img/honor_001.a61bfdf.png";